import { RouterProvider } from 'react-router';
import { router } from '@/app/routes';
import { PrivyProvider } from '@privy-io/react-auth';
import { toSolanaWalletConnectors } from '@privy-io/react-auth/solana';
import { QueryProvider } from '@/api/providers/QueryProvider';
import { PrivyAuthSync } from '@/app/components/PrivyAuthSync';

// Solana connectors enable Phantom/Solflare browser extensions instead of "download wallet" prompt
const solanaConnectors = toSolanaWalletConnectors({
  shouldAutoConnect: false, // avoids extension popup on page load
});

export default function App() {
  return (
    <PrivyProvider
      appId={import.meta.env.VITE_PRIVY_APP_ID || ''}
      config={{
        loginMethods: ['wallet'],
        appearance: {
          theme: 'dark',
          walletChainType: 'solana-only',
          walletList: ['phantom', 'solflare', 'detected_solana_wallets'],
        },
        embeddedWallets: {
          createOnLogin: 'off',
        },
        externalWallets: {
          solana: {
            connectors: solanaConnectors,
          },
        },
      }}
    >
      <QueryProvider>
        <PrivyAuthSync />
        <RouterProvider router={router} />
      </QueryProvider>
    </PrivyProvider>
  );
}
